import React, { useEffect } from 'react';
import { useParams, Redirect } from 'cccisd-react-router';
import { NotFound } from 'cccisd-laravel-boilerplate';
import { LicensePrompt } from 'cccisd-laravel-licensing';
import Loader from 'cccisd-loader';

import { useDispatch, useSelector } from 'react-redux';
import { getProducts } from '../../reducers/products';
import { getLicenseStatus, getTrainingStatus } from '../../reducers/userAccess';

import ProductHeader from './components/ProductHeader';
import Footer from '../../components/Footer';
import style from './style.css';

import TrainingPrompt from './components/TrainingPrompt';

const Fortress = window.cccisd.fortress;
const pawnId = Fortress.user.acting.id;

export default function ProductLayout(props) {
    const { productHandle } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            dispatch(getProducts(productHandle));
            dispatch(getLicenseStatus({ productHandle, pawnId }));
            dispatch(getTrainingStatus({ productHandle, pawnId }));
        })();
    }, [dispatch]);

    const { productId, productLabel } = useSelector(state => state.app.products);
    const { licensed, loading } = useSelector(state => state.app.userAccess);

    if (productHandle === ':productHandle') {
        return (
            <div className={`container ${style.body}`}>
                <Redirect to="/" />
            </div>
        );
    }

    if (loading) {
        return <Loader loading />;
    }

    if (productId && !licensed) {
        return <LicensePrompt productId={productId} />;
    }

    return (
        <div className={style.background}>
            <div className={style.wrapper}>
                <ProductHeader
                    className={props.className}
                    product={{
                        label: productLabel ? productLabel : null,
                        handle: productHandle,
                    }}
                />

                <div className={`container ${style.body}`}>
                    {loading ? (
                        <Loader loading />
                    ) : (
                        <>{licensed ? <TrainingPrompt>{props.children}</TrainingPrompt> : <NotFound />}</>
                    )}
                </div>

                <div className={style.footer}>
                    <Footer className={props.className} />
                </div>
            </div>
        </div>
    );
}
